export default "__VITE_ASSET__4e9daa59__"